// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import './assets/css/reset.css'
import {
  post,
  get,
  patch,
  put
} from './utils/https'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible/flexible'
Vue.use(Vant)

Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js